import { MODAL_TYPES } from 'constants/general';
import { SETTINGS_DELETE_TARGET } from 'enums';

export const SETTINGS_DELETE_MODAL_TYPE: Record<
  SETTINGS_DELETE_TARGET,
  string
> = {
  [SETTINGS_DELETE_TARGET.HABIT]: MODAL_TYPES.CONFIRM_HABIT_DELETION,
  [SETTINGS_DELETE_TARGET.CUSTOM_ROUTINE]:
    MODAL_TYPES.CONFIRM_CUSTOM_ROUTINE_DELETION
};

export const SETTINGS_DELETE_NAMED_COPY_KEYS: Record<
  SETTINGS_DELETE_TARGET,
  string
> = {
  [SETTINGS_DELETE_TARGET.HABIT]: 'settings_page.confirm_delete_habit',
  [SETTINGS_DELETE_TARGET.CUSTOM_ROUTINE]:
    'settings_page.confirm_delete_custom_routine'
};

export const SETTINGS_DELETE_UNNAMED_COPY_KEYS: Record<
  SETTINGS_DELETE_TARGET,
  string
> = {
  [SETTINGS_DELETE_TARGET.HABIT]: 'settings_page.confirm_delete_unnamed_habit',
  [SETTINGS_DELETE_TARGET.CUSTOM_ROUTINE]:
    'settings_page.confirm_delete_unnamed_custom_routine'
};

export const MAIN_ROW_FIELD_KEYS = new Set([
  'name',
  'habit_icon',
  'duration_seconds',
  'completion_requirements',
  'id',
  'activity_sequence_id',
  'activity_type',
  'category',
  'days_of_week'
]);
